import React from 'react';
import { format, addDays, subDays, addWeeks, subWeeks, addMonths, subMonths } from 'date-fns';

export default function CalendarHeader({ selectedDate, onDateSelect, view, onViewChange, onToggleSidebar }) {
  const navigate = (dir) => {
    const fns = {
      day: dir === 1 ? addDays : subDays,
      week: dir === 1 ? addWeeks : subWeeks,
      month: dir === 1 ? addMonths : subMonths,
    };
    onDateSelect(fns[view](selectedDate, 1));
  };

  const label = {
    day: format(selectedDate, 'EEEE, MMMM d, yyyy'),
    week: `Week of ${format(selectedDate, 'MMM d, yyyy')}`,
    month: format(selectedDate, 'MMMM yyyy'),
  }[view];

  const shortLabel = {
    day: format(selectedDate, 'MMM d'),
    week: format(selectedDate, 'MMM d'),
    month: format(selectedDate, 'MMM yyyy'),
  }[view];

  return (
    <div className="flex items-center justify-between px-4 md:px-7 py-3 border-b border-theme bg-secondary">
      <div className="flex items-center gap-1.5 md:gap-2">
        {/* Mobile sidebar toggle */}
        <button
          onClick={onToggleSidebar}
          className="lg:hidden w-[34px] h-[34px] flex items-center justify-center bg-tertiary border border-theme rounded-[9px] text-secondary-c text-lg"
        >
          &#9776;
        </button>

        <button
          onClick={() => navigate(-1)}
          className="w-[34px] h-[34px] flex items-center justify-center bg-tertiary border border-theme rounded-[9px] text-secondary-c hover:bg-hover-surface hover:text-primary-c transition-all text-lg"
        >
          &#8249;
        </button>
        <button
          onClick={() => onDateSelect(new Date())}
          className="h-[34px] px-3.5 flex items-center justify-center bg-tertiary border border-theme rounded-[9px] text-[12px] font-semibold text-secondary-c hover:bg-hover-surface hover:text-primary-c transition-all tracking-wide"
        >
          Today
        </button>
        <button
          onClick={() => navigate(1)}
          className="w-[34px] h-[34px] flex items-center justify-center bg-tertiary border border-theme rounded-[9px] text-secondary-c hover:bg-hover-surface hover:text-primary-c transition-all text-lg"
        >
          &#8250;
        </button>

        <h2 className="hidden md:block text-[17px] font-bold ml-3 tracking-tight text-primary-c">{label}</h2>
        <h2 className="md:hidden text-[14px] font-bold ml-2 tracking-tight text-primary-c">{shortLabel}</h2>
      </div>

      <div className="flex gap-0.5 bg-tertiary p-[3px] rounded-[9px]">
        {['day', 'week', 'month'].map(v => (
          <button
            key={v}
            onClick={() => onViewChange(v)}
            className={`px-3 md:px-4 py-1.5 rounded-[7px] text-[12px] font-semibold transition-all
              ${view === v ? 'bg-accent text-white shadow-glow' : 'text-muted-c hover:text-primary-c'}`}
          >
            <span className="hidden sm:inline">{v.charAt(0).toUpperCase() + v.slice(1)}</span>
            <span className="sm:hidden">{v.charAt(0).toUpperCase()}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
